import { api } from "../ApiState";
import { IApiResponse } from "../../Types/ApiResponse.model";
import { setMenuInfo, setProfile } from "../Slice/Settings.state";

export const authApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // first step of login
    authLogin: builder.mutation<IApiResponse<any>, string>({
      query: (phone) => ({
        url: "auth/code",
        method: "POST",
        body: { phone: phone },
      }),
    }),

    // second step of login (verify)
    authVerify: builder.mutation<
      IApiResponse<any>,
      { phone: string; code: string }
    >({
      query: (data) => ({
        url: "auth/login",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const {
            data: { response },
          } = await queryFulfilled;

          if (response.status === "success") {
            // handle save token
            const token = response?.data?.token && response.data.token;
            token && localStorage.setItem("token", token);
          }
        } catch (error) {}
      },
    }),

    // third step of login (two-step-verify)
    authTwoVerify: builder.mutation<
      IApiResponse<any>,
      { phone: string; password: string }
    >({
      query: (data) => ({
        url: "auth/twoverify",
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const {
            data: { response },
          } = await queryFulfilled;

          if (response.status === "success") {
            // handle save token
            const token = response?.data?.token && response.data.token;
            token && localStorage.setItem("token", token);
          }
        } catch (error) {}
      },
    }),

    // get admin information
    getAdminInfo: builder.query<any, undefined>({
      query: () => ({
        url: "profile/show",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const {
            data: { response },
          } = await queryFulfilled;

          if (response?.status === "success") {
            // handle save admin info
            const profile = response?.data && response.data;
            if (profile) {
              dispatch(setProfile({ ...profile }));
            }
          }
        } catch (error) {}
      },
    }),

    getMenuInfo: builder.query<any, undefined>({
      query: () => ({
        url: `/menu/info`,
        method: "GET",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const {
            data: { response },
          } = await queryFulfilled;

          if (response.status === "success") {
            // handle save menu info
            const menuInfo = response?.data && response.data;
            if (menuInfo) {
              dispatch(setMenuInfo(menuInfo));
            }
          }
        } catch (error) {}
      },
    }),

    // logout
    authLogout: builder.mutation<any, void>({
      query: () => ({
        url: `logout`,
        method: "POST",
        body: { _method: "PUT" },
      }),
    }),
  }),
});

export const {
  useAuthLoginMutation,
  useAuthVerifyMutation,
  useAuthTwoVerifyMutation,
  useGetAdminInfoQuery,
  useGetMenuInfoQuery,
  useAuthLogoutMutation,
} = authApi;

export default authApi;
